<template>
  <div class="tile-preview-container">
    <div class="tile-promo-display-selections-div">
      <div class="tab-selector mr-4">
        <RfLiquidPreview
          v-model:userData="liquidContextStore.previewUserContext"
          :appId="appsStore.app?.id"
        />
        <RfLanguagePreview
          v-if="model.device_type !== 'tv_os' || appsStore.app?.flags?.legacy_apple_editor"
          :model="model"
          :actions="actions"
        />
      </div>
    </div>

    <div class="h-full w-full overflow-auto">
      <RfRetentionModal
        ref="tv"
        :model="model"
        class="h-full w-full cursor-not-allowed"
        :actions="previewActions"
        :zoomStyle="zoomStyle"
        :deviceType="isNewTvInterstitial ? 'new_tv' : 'tv_os'"
        :newButtonStyles="isNewTvInterstitial"
        :isNewDeviceEditor="
          model.path_type === 'retention_modal' &&
          ((model.device_type === 'tv_os' && !appsStore.app?.flags?.legacy_apple_editor) ||
            (model.device_type === 'android_tv' && appsStore.app?.flags?.new_android_editor))
        "
        :retentionTypeVideo="retentionTypeVideo"
      />
    </div>
    <div v-if="viewTabModal === 'desktopViewTab'" class="preview-control-buttons">
      <v-btn size="small" color="#f3f3f3" @click="zoomIn">+</v-btn>
      <v-btn class="reset-zoom-btn" size="small" color="#f3f3f3" @click="resetZoom">{{
        `${zoomValue * 100}%`
      }}</v-btn>
      <v-btn size="small" color="#f3f3f3" @click="zoomOut">-</v-btn>
    </div>
    <component :is="'style'" v-if="actions.rf_settings_custom_css">
      {{ actions.rf_settings_custom_css }}
    </component>
  </div>
</template>

<script>
import RfRetentionModal from "@/components/RfPathCreate/RfRetentionActions/RfRetentionModal.vue";
import ZoomPreviewMixin from "@/utils/ZoomPreviewMixin";
import LanguagePreviewMixin from "@/utils/LanguagePreviewMixin";
import RfLanguagePreview from "@/components/RfPathCreate/RfRetentionDevices/RfLanguagePreview.vue";
import CompositeImageSaver from "@/utils/CompositeImageSaver";
import { useAppsStore } from "@/pinia/appsStore";
import { DefaultDeviceOptions } from "@/utils/constants/DevicesConstants";
import RfLiquidPreview from "./RfLiquidPreview.vue";
import { PromptTypes } from "@/utils/constants/PromoTypesConstants";
import { useLiquidContextStore } from "@/pinia/liquidContextStore";

export default {
  name: "RfRetentionDeviceTvOs",
  components: { RfRetentionModal, RfLanguagePreview, RfLiquidPreview },
  mixins: [ZoomPreviewMixin, LanguagePreviewMixin],
  props: ["actions", "viewTypeTab", "model", "retentionTypeVideo"],
  setup: () => ({
    appsStore: useAppsStore(),
    DefaultDeviceOptions,
    liquidContextStore: useLiquidContextStore(),
  }),
  data() {
    return { showErrors: true, viewTabModal: this.viewTypeTab };
  },
  computed: {
    isNewTvInterstitial() {
      return (
        [
          DefaultDeviceOptions.roku_os.value,
          DefaultDeviceOptions.android_tv.value,
          DefaultDeviceOptions.tv_os.value,
        ].includes(this.model.device_type) &&
        this.model.path_type === PromptTypes.interstitial.value
      );
    },
  },
  methods: {
    async fillModel(model) {
      await CompositeImageSaver.fill(model, this.$refs, this.appsStore.app);
    },
  },
};
</script>
